import { Fragment, useRef } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon, PaintBrushIcon } from "@heroicons/react/20/solid";
import { Spinner } from "./Spinner";
import { BoltIcon } from "@heroicons/react/24/solid";
import { PaperClipIcon } from "./create/CreatePrompt";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
export default function CreateButton(props) {
    const fileInputRef = useRef(null);
    const hasMenu = !props.hideMenu;
    const handleFileSelect = (e) => {
        const file = e.target.files?.[0];
        console.log("file", file);
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                props.onUpload?.(e.target.result);
            };
            reader.readAsArrayBuffer(file);
        }
    };
    return (
        <div className=" inline-flex shadow-sm w-full">
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileSelect}
                accept=".png,.jpg,.jpeg,.webp"
                className="hidden"
            />
            <button
                disabled={props?.isCreating}
                onClick={(e) => {
                    props?.onCreate();
                    e.preventDefault();
                }}
                className={classNames(
                    "inline-flex items-center bg-secondary-dark hover:bg-secondary-darkest disabled:bg-gray-500 w-full justify-center rounded-l-md border border-transparent px-3 lg:px-8 py-1 lg:py-2  text-base font-medium text-white shadow-sm  focus:outline-none sm:col-start-2",
                    props.hideMenu ? "rounded-md" : "rounded-l-md"
                )}
            >
                {props?.isCreating ? (
                    <div className="sm:-ml-2 mr-1 flex-shrink w-6 h-6 pl-1 sm:pl-0">
                        <Spinner />
                    </div>
                ) : (
                    <BoltIcon className="-ml-2 w-5 h-5 mr-1 sm:mr-2 pl-1 sm:pl-0" />
                )}
                Create
            </button>
            {hasMenu && (<Menu as="div" className="relative -ml-px block">
                <Menu.Button
                    disabled={props?.isCreating}
                    className="border disabled:bg-gray-500 disabled:border-l-gray-600 disabled:border-gray-500 border-secondary-dark hover:border-secondary-darkest border-l-secondary-darkest relative inline-flex items-center rounded-r-md bg-secondary-dark px-2 py-2 text-white hover:bg-secondary-darkest focus:z-10 disabled:text-gray-300"
                >
                    <span className="sr-only">Open options</span>
                    <ChevronDownIcon className="h-6 w-5" aria-hidden="true" />
                </Menu.Button>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="cursor-pointer absolute bottom-full right-0 z-10 -mr-1 my-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-0 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-700 dark:ring-gray-600 dark:text-gray-100">
                        <div className="py-1">
                            <Menu.Item>
                                {({ active }) => (
                                    <a
                                        onClick={() => props.onCreate?.()}
                                        className={classNames(
                                            active
                                                ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-100"
                                                : "text-gray-700 dark:text-gray-100",
                                            "block px-4 py-2 text-sm"
                                        )}
                                    >
                                        <div className="flex items-center">
                                            <div>
                                                <BoltIcon className="w-4 h-4 mr-3" />
                                            </div>
                                            <div>Create Single Image</div>
                                        </div>
                                    </a>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <a
                                        onClick={() => props.onBulkCreate?.()}
                                        className={classNames(
                                            active
                                                ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-100"
                                                : "text-gray-700 dark:text-gray-100",
                                            "block px-4 py-2 text-sm"
                                        )}
                                    >
                                        <div className="flex items-center">
                                            <div>
                                                <svg
                                                    viewBox="0 0 20.001711 20.001542"
                                                    className="w-4 h-3 mr-3"
                                                    x="0px"
                                                    y="0px"
                                                    fill="currentColor"
                                                    version="1.1"
                                                    width="20.001711"
                                                    height="20.001543"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <g transform="translate(3.4893159e-4,4.7922182e-4)">
                                                        <g
                                                            data-name="Layer 1"
                                                            id="g1"
                                                        >
                                                            <path d="m 20,10.27 v 8.34 A 1.33,1.33 0 0 1 18.65,20 H 10.31 A 1,1 0 0 1 9.69,19.82 1.78,1.78 0 0 1 9.24,19.46 1.28,1.28 0 0 1 9,18.61 v -2.24 h 5.2 a 2.22,2.22 0 0 0 2.24,-2.24 V 8.92 h 2.24 A 1.33,1.33 0 0 1 20,10.27 Z M 9.64,15.52 h 4.49 a 1.32,1.32 0 0 0 1.34,-1.35 V 5.83 A 1.32,1.32 0 0 0 14.13,4.48 H 11.88 V 9.69 A 2.12,2.12 0 0 1 11.31,11.16 3.62,3.62 0 0 1 8.5,12 H 7.2 4.44 v 2.24 a 1.32,1.32 0 0 0 1.34,1.35 H 9.64 Z M 8.07,10.94 H 9.69 A 1.22,1.22 0 0 0 10.58,10.58 1.38,1.38 0 0 0 10.81,10.31 1.47,1.47 0 0 0 11,9.64 V 1.3 A 1.3,1.3 0 0 0 10.82,0.63 1.38,1.38 0 0 0 10.59,0.36 1.22,1.22 0 0 0 9.69,0 H 1.35 A 1.32,1.32 0 0 0 0,1.35 V 9.6 a 1.32,1.32 0 0 0 1.35,1.34 z" />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div>Bulk Create</div>
                                        </div>
                                    </a>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <a
                                        onClick={() => props.onSketch?.()}
                                        className={classNames(
                                            active
                                                ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-100"
                                                : props.hasSketch
                                                ? " text-secondary  dark:text-secondary-light"
                                                : "text-gray-700 dark:text-gray-100",
                                            "block px-4 py-2 text-sm lg:hidden"
                                        )}
                                    >
                                        <div className="flex items-center">
                                            <div>
                                                <PaintBrushIcon className="w-4 h-3 mr-3" />
                                            </div>
                                            <div>Sketch</div>
                                        </div>
                                    </a>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <a
                                        onClick={() =>
                                            fileInputRef.current.click()
                                        }
                                        className={classNames(
                                            active
                                                ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-100"
                                                : props.hasUpload
                                                ? " text-secondary  dark:text-secondary-light"
                                                : "text-gray-700 dark:text-gray-100",

                                            "block px-4 py-2 text-sm lg:hidden"
                                        )}
                                    >
                                        <div className="flex items-center">
                                            <div>
                                                <PaperClipIcon className="w-4 h-3 mr-3" />
                                            </div>
                                            <div>Attach</div>
                                        </div>
                                    </a>
                                )}
                            </Menu.Item>
                        </div>
                        </Menu.Items>
                        </Transition>
                    </Menu>
                )}
        </div>
    );
}
